﻿// src/js/main.js
import { initFortuner } from './Fortuner.js';
import { initDefender } from './Defender.js';

const models = [
    { name: 'Fortuner', init: initFortuner },
    { name: 'Defender', init: initDefender }
];

let currentIndex = 0;

function clearScene() {
    document.body.innerHTML = ''; // Reset all content
}

function loadModel(index) {
    clearScene();
    models[index].init(document.body);
    addSwitchControls();
}

// function addSwitchControls() {
//     const left = document.createElement('img');
//     const right = document.createElement('img');
//     left.src = '../assets/arrow.png';
//     right.src = '../assets/arrow.png';

//     [left, right].forEach(btn => {
//         Object.assign(btn.style, {
//             position: 'absolute',
//             top: '50%',
//             width: '40px',
//             height: '40px',
//             cursor: 'pointer',
//             userSelect: 'none',
//             zIndex: 1000
//         });
//         document.body.appendChild(btn);
//     });

//     left.style.left = '10px';
//     left.style.transform = 'translateY(-50%) rotateY(180deg)';
//     right.style.right = '10px';
//     right.style.transform = 'translateY(-50%)';

//     left.onclick = () => {
//         currentIndex = (currentIndex - 1 + models.length) % models.length;
//         loadModel(currentIndex);
//     };

//     right.onclick = () => {
//         currentIndex = (currentIndex + 1) % models.length;
//         loadModel(currentIndex);
//     };
// }

window.addEventListener('load', () => loadModel(currentIndex));
